/*-----------Types of AUTH actions--------*/

export const PROFILE_FETCHED = "PROFILE_FETCHED";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOCK = "USER_LOCK";
export const USER_UNLOCK = "USER_UNLOCK";
export const USER_FETCHED = "USER_FETCHED";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const IN_AUTH = "IN_AUTH"; //en cours d'authentification
export const AUTH_FAILED_ONLOADING = "AUTH_FAILED_ONLOADING";
